


































import '@/globals';
import Vue from 'vue';
import Component from 'vue-class-component';
import HomeCard from '@/components/home-card.vue';
import { Poi } from '@/models/poi';
import { urlize } from '@/utils';
import Bro from 'brototype';

@Component({
    components: { HomeCard }
})
export default class ArLauncherPage extends Vue {
    public arPois = new Array<Poi>();

    public mounted() {
        this.arPois = this.$store.pois.filter(poi => poi.is_special);
    }

    public resolveArLink(poi: Poi): string {
        return "/pois/" + poi.id + "/ar/";
    }

    public openArLink(poi: Poi): void {
        this.$f7router.navigate(this.resolveArLink(poi));
    }

    public getPoiCaption(poi: Poi) {
        if (Bro(poi).doYouEven('content_ar_experiences.0.caption')) {
            return poi.content_ar_experiences[0].caption;
        }

        return '';
    }

    public getPoiImage(poi: Poi) {
        if (Bro(poi).doYouEven('content_ar_experiences.0.preview.medium')) {
            return urlize(poi.content_ar_experiences[0].preview.medium);
        }

        return '';
    }
}
